export const API_URL = "https://clownfish-app-6u8tb.ondigitalocean.app";
